import { AdminTemplate, MasterPassAddForm } from "../../components"

export const MasterPassAddPage = () => {
  return (
    <AdminTemplate
      headerProps={{
        headerTitle: 'Masterpass Üye İşyeri Tanımı ',
        hideAddButton: true,
        hideDownloadButton: true,
        hideSearchBar: true
      }}>
      <MasterPassAddForm />
    </AdminTemplate>
  )
}
